import React from 'react';
import { Field, FormSpy } from 'react-final-form';
import { isPositiveNumber, isBelowAccessibilityThreshold } from '../../../../../common/utils/fieldValidators';
import Checkbox from '@mdigital/components/dist/components/Checkbox';
import StyledDuration from './StyledDuration';

const Duration = () => {
  const handleDurationChanged = (event, input) => {
    const { value } = event.target;
    const minVal = value > 0 ? value : 1;
    input.onChange(minVal);
  };

  return (
    <FormSpy subscription={{ values: true }} render={({ values }) => {
      const isBelowThreshold = isBelowAccessibilityThreshold(values.trigger.triggerCustomBannerContract.invitationTimeout);
      return (
        <StyledDuration>
          <div className='row'>
            <div className="duration-input">
              <Field validate={isPositiveNumber}
                name="trigger.triggerCustomBannerContract.invitationTimeout"
                render={({ input }) => (
                  <input min="1" type="number" {...input}
                    className={isBelowThreshold ? 'warning' : ''}
                    onChange={(event) => handleDurationChanged(event, input)}
                    disabled={values.trigger.triggerCustomBannerContract.isSticky} />
                )} />
              <label>Sec</label>
            </div>
            <div className="is-sticky-cb">
              <span>
                <p>Or</p>
              </span>
              <span data-testid="Duration">
                <Field name="trigger.triggerCustomBannerContract.isSticky" render={({ input }) => (
                  <Checkbox label="Sticky" digIsChecked={input.value} handleCheckboxChange={input.onChange} />
                )} />
              </span>
            </div>
          </div>
          {!!isBelowThreshold &&
            <div className="warning">
              <span>
                {isBelowThreshold}
              </span>
            </div>
          }
        </StyledDuration>
      );
    }} />
  );
};

export default Duration;
